import React, { useState, useEffect } from 'react';
import {
  Row, Col, Modal, ModalBody, ModalFooter, Button,
  Dropdown, DropdownToggle, DropdownMenu, DropdownItem, FormGroup,
  Input, Label, Badge
} from 'reactstrap';
import { toast } from 'react-toastify';
import moment from 'moment'
import { AvForm, AvField } from 'availity-reactstrap-validation';
import api from '~/services/api';

export default function NewUser(props) {
  const [show, setShow] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [subscription, setSubscription] = useState(null)
  const [folders, setFolders] = useState([]);
  const [showDDFolder, setShowDDFolder] = useState(false);
  const [currentFolder, setCurrentFolder] = useState({ name: 'Selecionar Pasta', id: -1 });
  const [roles, setRoles] = useState([]);
  const [coach, setCoach] = useState();
  const [userRoles, setUserRoles] = useState([]);
  const [cpf, setCpf] = useState(props.user?.cpf || '');

  const maskCpf = (value) => {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
      .slice(0, 14);
  };

  const unmaskCpf = (value) => value.replace(/\D/g, '');

  useEffect(() => {
    if (props.user?.cpf) setCpf(maskCpf(props.user.cpf));
  }, [props.user]);

  useEffect(() => {
    if (props.user && props.user.id > 0) {
      delete props.user.password

      props.user.birth = moment(props.user.birth).format('YYYY-MM-DD')

      if (props.user.return_to_trainings_at) {
        props.user.return_to_trainings_at = moment(props.user.return_to_trainings_at).utcOffset(0, false).format('YYYY-MM-DD')
      }

      setUserRoles(props.user.roles.map(role => role.id))

      setDisabled(props.user.disabled);
    }

    if (props.user && props.user.folder && props.user.folder.id > 0) {
      setCurrentFolder(props.user.folder)
    }
    
    if (props.user && props.user.subscriptions && props.user.subscriptions.length > 0) {
      setSubscription(props.user.subscriptions[0])
    }
  }, [props.user])

  useEffect(() => {
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function loadData() {
    Promise.all([api.get('folders'), api.get('roles')])
      .then(([folderResp, rolesResp]) => {
        setFolders(folderResp.data);
        setRoles(rolesResp.data);
      });

    if (props.user && props.user.coach_id) {
      const coach = await api.get(`/users/${props.user.coach_id}`);
      setCoach(coach.data)
    }
  }

  const handleUserSubmit = async (event, errors, values) => {
    if (!values.name) { toast.error('Atribua um nome para o usuário'); return }

    if (!values.email) { toast.error('Atribua um email para o usuário'); return; }

    if (!values.password && !props.user) { toast.error('Atribua uma senha para o usuário'); return; }

    if (values.password && !values.password_confirmation && !props.user) { toast.error('Confirme a senha para o usuário'); return; }

    if (!values.genre) values.genre = 'M'

    if (userRoles.length > 0) {
      values.roles = userRoles
    } else {
      toast.error('Atribua uma permissão para o usuário'); return;
    }

    if (currentFolder.id > 0) { values.folder_id = currentFolder.id }

    if (subscription && props.user && props.user.id > 0) {
      values.subscription_id = subscription.id
    }

    if (values.cpf) {
      values.cpf = unmaskCpf(cpf);
    }

    try {
      let resp = {};

      let toastMessage = ''
      let toastErrorMessage = ''
      values.disabled = disabled

      if (props.user && props.user.id > 0) {
        resp = await api.put(`users/${props.user.id}`, values)
        toastMessage = 'Usuário atualizado com sucesso'
        toastErrorMessage = 'Erro ao atualizar usuário'
      } else {
        resp = await api.post('users', values)
        toastMessage = 'Usuário criado com sucesso'
        toastErrorMessage = 'Erro ao criar usuário'
      }

      if (resp.status >= 200 && resp.status < 300) {
        toast.success(toastMessage)
        setShow(!show)

        if (props.user && props.user.id > 0) {
          if (props.searchQuery && props.searchQuery.length > 0) {
            props.handleSetSearchQuery(props.user.email)
            props.handleSearchUser()
          } else {
            props.loadUsers(props.selectedPage)
          }
        }
      } else {
        toast.warn(toastErrorMessage)
      }
    } catch (error) {
      toast.error('Aconteceu um erro ao salvar usuário')
    }
  }

  const appendUserRole = (id) => {
    if (userRoles.length > 0) {
      if (id && !userRoles.some(userRole => userRole === id)) {
        setUserRoles(prev => [...prev, id]);
      }
    } else {
      setUserRoles([id]);
    }
  }

  const removeUserRole = (id) => {
    if (userRoles.length > 0 && userRoles.some(userRole => userRole === id)) {
      const filtered = userRoles.filter(item => item !== id);
      setUserRoles(filtered);
    }
  }

  const getRoleName = (id) => {
    return roles.some(role => role.id === id) ? roles.find(role => role.id === id).name : '--'
  }

  return (
    <Modal style={{ maxWidth: '2600px', width: '95%', maxHeight: '1600px', height: '95%' }} isOpen={show} toggle={() => props.toggle(!show)}>

      <AvForm onSubmit={handleUserSubmit} model={props.user}>
        <ModalBody>
          <Row>
            <Col lg={12}>
              <Row>
                <Col lg={6}>
                  <AvField style={{}} label="Nome" placeholder="Nome completo" name="name" />
                  <AvField style={{}} label="Email" placeholder="Email" name="email" />
                  <AvField style={{}} label="Telefone" placeholder="phone" name="phone" />
                  <AvField
                    style={{}}
                    label="CPF"
                    placeholder="CPF"
                    name="cpf"
                    value={cpf}
                    onChange={e => setCpf(maskCpf(e.target.value))}
                    maxLength={14}
                  />
                  <AvField style={{}} label="Senha" placeholder="Senha" name="password" />
                  <AvField style={{}} label="Confirmação de senha" placeholder="Confirmação de senha" name="password_confirmation" />
                  <AvField style={{}} label="Biografia" placeholder="Texto descritivo" name="bio" />
                  <FormGroup check inline>
                    <Input type="checkbox" checked={disabled} onChange={(e) => setDisabled(e.target.checked)} />

                    <Label check>Desabilitado</Label>
                  </FormGroup>
                  {coach?.name && <>
                    <h2><span>Treinador</span></h2>
                    <h3><span className={` badge badge-primary`}> {coach?.name}</span></h3>
                  </>}
                </Col>
                <Col lg={6}>
                  <AvField style={{}} type="date" label="Nascimento" placeholder="Data de nascimento" name="birth" />
                  <AvField type="select" label="Gênero" name="genre" style={{}}>
                    <option>M</option>
                    <option>F</option>
                  </AvField>
                  <AvField style={{}} label="Peso" placeholder="Peso em kg" name="weight" />
                  <AvField style={{}} label="Altura" placeholder="Altura em cm" name="height" />
                  <AvField type="select" label="Tipo de acesso" name="subscription_type" style={{}}>
                    <option value="FREE">FREE</option>
                    <option value="ESSENTIAL">ESSENCIAL</option>
                    <option value="PERSONAL">PERSONAL</option>
                    <option value="BASIC">BASIC</option>
                    <option value="START">START</option>
                  </AvField>
                  <AvField style={{}} type="date" label="Data para retorno" placeholder="Data para retorno" name="return_to_trainings_at" />
                  
                  <FormGroup>
                    <Label for="user_roles">Selecione as permissões do usuário</Label>
                    <Input type="select" name="user_roles" id="user_roles" onChange={e => appendUserRole(parseInt(e.target.value))}>
                      <option value={0}>Selecione</option>
                      {
                        roles.map(role => (
                          <option key={role.id} value={role.id}>{role.name}</option>
                        ))
                      }
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label>Selecionadas:&nbsp;</Label>
                    {
                      userRoles.length > 0 ?
                        userRoles.map(userRole => (
                          <Badge key={userRole} className="mr-1" onClick={() => removeUserRole(parseInt(userRole))} style={{ cursor: 'pointer' }}>
                            {getRoleName(parseInt(userRole))}&nbsp;&nbsp;X
                          </Badge>
                        ))
                        :
                        <Badge>
                          Todas
                        </Badge>
                    }
                  </FormGroup>

                  <Row>
                    <Col lg={4}>
                      <Dropdown isOpen={showDDFolder} toggle={() => setShowDDFolder(!showDDFolder)} >
                        <DropdownToggle style={{ width: 150, marginRight: 10 }}> {currentFolder.name} </DropdownToggle>
                        <DropdownMenu
                          modifiers={{
                            setMaxHeight: {
                              enabled: true, order: 890, fn: (data) => {
                                return { ...data, styles: { ...data.styles, overflow: 'auto', maxHeight: 400, } }
                              }
                            }
                          }} >
                          {folders.map((elem, index) => {
                            return (
                              <DropdownItem key={index} onClick={() => setCurrentFolder(elem)}>{elem.name}</DropdownItem>
                            )
                          })}
                        </DropdownMenu>
                      </Dropdown>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={() => props.toggle(!show)}>Cancelar</Button>
          <FormGroup>
            <Button color="success" >Salvar e Fechar</Button>
          </FormGroup>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
}
